import BasePolicy from '@/policies/BasePolicy.js';

export default class InterventionPolicy extends BasePolicy {
    viewAny(user) {
        return user.hasPermissionTo('view all Interventions') || user.hasGroupPermissionTo('view all Interventions');
    }
}
